// src/filters/avatar.js
export const formatAvatar = (avatar) => {
  if (avatar && !avatar.startsWith("http")) {
    return `https://www.rent.move2china.com/avatarimg/${avatar}`;
  }
  return avatar;
};
